// 导入 axios
import axios from 'axios'
/*ElementUI*/
import ele from 'element-ui'
// vuex
import store from '../store/index.js'
import router from '../router/index.js'

// 默认请求格式
axios.defaults.headers['Content-Type'] = 'multipart/form-data';
// 创建 axios 实例
const justpost = axios.create({
    baseURL: '/api',
    timeout: 6000
})

// 错误处理函数
const err = (error) => {
	// 请求错误时做些事
	    let status = "";
	    if (error.request) {
	      status = error.request;
	    } else if (error.response) {
	      status = error.response;
	    }
	    if (status) {
	      switch (status.status) {
	        case 400:
	          error.message = "请求错误(400)";
	          break;
	        case 401:
	          error.message = "未授权，请重新登录(401)";
	          break;
	        case 403:
	          error.message = "登录过期，请重新登录";
	          break;
	        case 404:
	          error.message = "请求出错(404)";
	          break;
	        case 408:
	          error.message = "请求超时(408)";
	          break;
	        case 500:
	          error.message = "服务器错误(500)，请稍后重试";
	          break;
	        case 501:
	          error.message = "服务未实现(501)";
	          break;
	        case 502:
	          error.message = "网络错误(502)";
	          break;
	        case 503:
	          error.message = "服务不可用(503)";
	          break;
	        case 504:
	          error.message = "网络超时(504)";
	          break;
	        case 505:
	          error.message = "HTTP版本不受支持(505)";
	          break;
	        default:
	          error.message = `连接出错(${error.response.status})!`;
	      }
	    } else {
	      error.message = "连接服务器失败!";
	    }
    return Promise.reject(error)
}

// request interceptor(请求拦截器)
justpost.interceptors.request.use(config => {
    const token = localStorage.getItem('Authorization')||'';
    config.headers['Authorization'] = token
	config.headers['InterfaceToken'] = store.state.InterfaceToken; // 接口通行证
	config.headers['Language'] = store.state.lang;
    return config
}, err)

// response interceptor（接收拦截器）
justpost.interceptors.response.use(response => {
    const res = response.data;
    return res;
}, err)

export default justpost